import React, {useEffect, useRef, useState} from 'react'
import ColorPicker from '../components/ColorPicker'

const baseSize = 128/4
const pixelWidth = baseSize
const pixelHeight = baseSize

const colorStrs = [
  'blue','purple','teal','red', 'white', 'yellow',
]

const Welcome = () => {
  const [mouseDown, setMouseDown] = useState(false)
  const [eraserMode, setEraserMode] = useState(false)
  const [context, setContext] = useState(null)
  const [myImage, setMyImage] = useState(null)
  const [myColor, setMyColor] = useState(null)

  const [rows, setRows]= React.useState(40)
  const [columns, setColumns]= React.useState(50)

  const [grid, setGrid] = useState(Array.apply(null, Array(rows)).map((row) => Array.apply(null, Array(columns)).map((i) => null)))
  const [colors, setColors] = useState([])

  const canvasRef = useRef(null)

  const getUpdatedGrid = (clickedC, clickedR, color) => {
    return grid.map((row, r) => {
      return row.map((col, c) =>{
        if(clickedC === c && clickedR === r) {
          return color
        }
        return col
      })
    })
  }

  const resizeEvent = React.useCallback(() => {
    const c = Math.floor(window.innerWidth / pixelWidth)
    const r = Math.floor(window.innerHeight / pixelHeight)

    setRows(r)
    setColumns(c)
    setGrid(Array.apply(null, Array(r)).map((row) => Array.apply(null, Array(c)).map((i) => null)))
  },[setRows,setColumns,setGrid])

  useEffect(() => {
    // set up canvas
    const canvas = canvasRef.current
    const canvasContext = canvas.getContext('2d')
    setContext(canvasContext)
    canvasContext.imageSmoothingEnabled = false;

    const colors = {}
    colorStrs.forEach((c) => {
      colors[c] =  new Image();
      colors[c].src = require(`../img/Knit-pattern_${c}.png`);
    })

    const color = colorStrs[0]
    document.querySelector('body').classList.add(color)
    setColors(colors)
    setMyColor(color)
    setMyImage(colors[color])

    window.addEventListener('resize', resizeEvent);
    resizeEvent()
  }, [resizeEvent])

  const draw = (column, row, toDraw, context) => {
    if(!context) {
      return
    }

    context.drawImage(toDraw, column * pixelWidth, row * pixelHeight, pixelWidth, pixelHeight)
  }

  const clear = (clickedC, clickedR) => {
    context.clearRect(clickedC * pixelWidth, clickedR * pixelWidth, pixelWidth, pixelWidth);
  }

  const click = (clickedC, clickedR) => {
    if (eraserMode) {
      clear(clickedC, clickedR)
    } else {
      const currentDrawing = grid[clickedR][clickedC]
      if(!currentDrawing) {
        draw(clickedC, clickedR, myImage, context)
      } else if (myImage === currentDrawing){
        //console.log("täs on jo samaa väriä hei")
      } else {
        clear(clickedC, clickedR)
        draw(clickedC, clickedR, myImage, context)
      }
    }

    const newGrid = getUpdatedGrid(clickedC, clickedR, eraserMode ? null : myImage)
    setGrid(newGrid)
  }

  const getMousePosOnGrid = (e) => {
    var elmnt = document.documentElement ? document.documentElement : document.body
    var x = elmnt.scrollLeft
    var y = elmnt.scrollTop

    const column = Math.floor((e.clientX + x) / pixelWidth)
    const row = Math.floor((e.clientY + y) / pixelHeight)

    return {
      column,
      row
    }
  }

  const mouseEvent = (e) => {
    const pos = getMousePosOnGrid(e)

    if (e.type === "mousedown" && !mouseDown) {
      setEraserMode(grid[pos.row][pos.column] ? true : false)
      setMouseDown(true)
      click(pos.column, pos.row)
    } else {
      setMouseDown(false)
    }
  }

  const mouseMove = (e) => {
    const pos = getMousePosOnGrid(e)

    if(mouseDown) {
      click(pos.column, pos.row)
    }
  }

  const changeColor = (color) => {
    setMyColor(color)
    setMyImage(colors[color])
  }

  return (
    <>
      <div
        onMouseDown={mouseEvent}
        onMouseUp={mouseEvent}
        onMouseMove={mouseMove}>
        <canvas ref={canvasRef}
          style={{ backgroundSize: `${pixelWidth}px ${pixelHeight}px`, backgroundPosition: `0px 0px` }}
          height={grid.length * pixelWidth}
          width={grid[0] ? grid[0].length * pixelHeight : 0}>
        </canvas>
      </div>
      <ColorPicker myColor={myColor} myImage={myImage} changeColor={changeColor} colors={colors}/>
    </>
  )
}

export default Welcome;
